import { httpClient } from '@/http/client';
import { AppSuccess, LoginBackofficeRequestBody } from 'bff';

export const loginUser = (
  data: LoginBackofficeRequestBody,
): Promise<AppSuccess> => httpClient.post(data, '/v1/backoffice/login').json();
